// src/guide/tickets/guide_voir_ticket.js
import {
  guide_tour_init,
  guide_tour_step_start,
  guide_tour_step,
  guide_tour_step_complete,
} from "@/guide/utils/guide_tour_actions";

export async function guide_voir_ticket(langs) {
  let translations;
  try {
    // Charge dynamiquement le JSON correspondant (ex: guide_traduction_fr.json)
    translations = (
      await import(`@/guide/traductions/guide_traduction_${langs}.json`)
    ).default;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des traductions pour la langue",
      langs,
      error
    );
    return;
  }
  const tour = guide_tour_init();

  guide_tour_step_start(
    tour,
    translations,
    translations.tickets.voir_ticket.page.titre,
    translations.tickets.voir_ticket.page.texte,
    "#page",
    ""
  );

  guide_tour_step(
    tour,
    translations,
    translations.tickets.voir_ticket.message.titre,
    translations.tickets.voir_ticket.message.texte,
    "#ticket"
  );

  if (document.getElementById("fermer")) {
    guide_tour_step_complete(
      tour,
      translations,
      translations.tickets.voir_ticket.fermer.titre,
      translations.tickets.voir_ticket.fermer.texte,
      "#fermer",
      "top"
    );
  } else if (document.getElementById("terminer")) {
    guide_tour_step(
      tour,
      translations,
      translations.tickets.voir_ticket.suivre.titre,
      translations.tickets.voir_ticket.suivre.texte,
      "#suivre"
    );

    guide_tour_step(
      tour,
      translations,
      translations.tickets.voir_ticket.terminer.titre,
      translations.tickets.voir_ticket.terminer.texte,
      "#terminer"
    );

    guide_tour_step_complete(
      tour,
      translations,
      translations.tickets.voir_ticket.repondre.titre,
      translations.tickets.voir_ticket.repondre.texte,
      "#repondre",
      "top"
    );
  } else {
    guide_tour_step_complete(
      tour,
      translations,
      translations.tickets.voir_ticket.repondre.titre,
      translations.tickets.voir_ticket.repondre.texte,
      "#repondre",
      "top"
    );
  }

  tour.start();
}
